function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var PurchaseTemplate = require('./purchase.template');
var _require = require('../purchase-service'),
  _startPurchase = _require.startPurchase;
var PurchaseLifecycle = require('../purchase-lifecycle');
function escapeHtml() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
var PurchaseOverlay = /*#__PURE__*/function () {
  function PurchaseOverlay(app, mod) {
    var _this = this;
    _classCallCheck(this, PurchaseOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, true, true, false);
    this.overlay["class"] = 'saito-overlay store-purchase-overlay-shell';
    this.overlay.clickBackdropToClose = false;
    this.overlay.nonBlocking = false;
    this.step = null;
    this.pendingTxSignature = '';
    this.listingTitle = '';
    this.nft_id = '';
    this.quantity = 1;
    /** True while the shared Transaction Monitor owns payment confirmation UX. */
    this.watchingWithMonitor = false;
    this._countdown_timer = null;
    this.app.connection.on('store-purchase-asset', function (data) {
      _this.onStorePurchaseAsset(data);
    });
    this.app.connection.on('store-order-refund', function () {
      _this.onStoreOrderRefund();
    });
    this.app.connection.on('store-purchase-lifecycle', function (purchase) {
      _this.onLifecycleChange(purchase);
    });
  }
  return _createClass(PurchaseOverlay, [{
    key: "lifecycle",
    value: function lifecycle() {
      return this.mod.purchase_lifecycle || null;
    }
  }, {
    key: "startPurchase",
    value: function () {
      var _startPurchase2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(summary) {
        var quantity,
          opts,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              quantity = _args.length > 1 && _args[1] !== undefined ? _args[1] : 1;
              opts = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              return _context.a(2, _startPurchase(this.app, this.mod, this, summary, quantity, opts));
          }
        }, _callee, this);
      }));
      function startPurchase(_x) {
        return _startPurchase2.apply(this, arguments);
      }
      return startPurchase;
    }()
  }, {
    key: "render",
    value: function render() {
      var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'fulfilling';
      if (step === 'complete') {
        this.openComplete();
        return;
      }
      this.openFulfilling();
    }

    /**
     * Payment broadcast confirmation via shared Saito Transaction Monitor.
     * On confirm, auto-advances into Store fulfillment UX (NFT arrival).
     * Live UX only — not recreated after reload.
     */
  }, {
    key: "watchPurchase",
    value: function watchPurchase(tx) {
      var _this2 = this;
      var listingTitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!(tx !== null && tx !== void 0 && tx.signature)) {
        console.error('Store: watchPurchase requires a signed transaction');
        return;
      }
      if (!this.mod.transaction_monitor) {
        console.error('Store: transaction_monitor is not initialized');
        return;
      }
      this.listingTitle = listingTitle || this.listingTitle;
      this.pendingTxSignature = tx.signature;
      if (meta.nft_id) {
        this.nft_id = String(meta.nft_id);
      }
      if (meta.quantity) {
        this.quantity = Math.max(1, Number(meta.quantity) || 1);
      }
      this.step = 'waiting';
      this.watchingWithMonitor = true;
      this.mod.transaction_monitor.render({
        tx: tx,
        title: 'Purchasing NFT',
        lead: 'Your purchase is being broadcast to the Saito network.',
        subtitle: '',
        auto_continue_on_confirm: true,
        callback: function callback(result) {
          _this2.watchingWithMonitor = false;
          if ((result === null || result === void 0 ? void 0 : result.status) === 'confirmed') {
            _this2.openFulfilling();
            return;
          }
          // Cancelled while waiting — lifecycle may still complete in background.
          _this2.step = null;
        }
      });
    }
  }, {
    key: "openFulfilling",
    value: function openFulfilling() {
      var _this$mod$transaction, _this$mod$transaction2;
      this.step = 'fulfilling';
      if (this._countdown_timer) {
        clearInterval(this._countdown_timer);
        this._countdown_timer = null;
      }
      this.show(PurchaseTemplate.fulfillingOverlay({
        listingTitle: escapeHtml(this.listingTitle)
      }));
      var heartbeatMs = ((_this$mod$transaction = this.mod.transaction_monitor) === null || _this$mod$transaction === void 0 || (_this$mod$transaction2 = _this$mod$transaction.getHeartbeatIntervalMs) === null || _this$mod$transaction2 === void 0 ? void 0 : _this$mod$transaction2.call(_this$mod$transaction)) || 30000;
      var cycle = Math.max(1, Math.round(2 * heartbeatMs / 1000));
      var seconds = cycle;
      var paint = function paint() {
        var el = document.querySelector('.purchase.fulfilling .countdown');
        if (el) {
          el.textContent = String(seconds);
        }
      };
      paint();
      this._countdown_timer = setInterval(function () {
        seconds -= 1;
        if (seconds <= 0) {
          seconds = cycle;
        }
        paint();
      }, 1000);
    }
  }, {
    key: "openComplete",
    value: function openComplete() {
      this.step = 'complete';
      if (this._countdown_timer) {
        clearInterval(this._countdown_timer);
        this._countdown_timer = null;
      }
      this.show(PurchaseTemplate.completeOverlay({
        listingTitle: escapeHtml(this.listingTitle)
      }));
      this.attachEvents();
    }
  }, {
    key: "show",
    value: function show(html) {
      var _this3 = this;
      var container = document.querySelector('.saito-container');
      container === null || container === void 0 || container.classList.add('store-purchase-modal-open');
      this.overlay.show(html, function () {
        _this3.onOverlayClosed();
      });
      this.applyOverlayLayout();
    }
  }, {
    key: "hide",
    value: function hide() {
      if (!this.step) {
        return;
      }
      this.overlay.close();
    }
  }, {
    key: "onOverlayClosed",
    value: function onOverlayClosed() {
      var _document$querySelect;
      (_document$querySelect = document.querySelector('.saito-container')) === null || _document$querySelect === void 0 || _document$querySelect.classList.remove('store-purchase-modal-open');
      if (this._countdown_timer) {
        clearInterval(this._countdown_timer);
        this._countdown_timer = null;
      }
      // Keep lifecycle / listing-hide / pendingTxSignature — only clear presentation step.
      this.step = null;
    }
  }, {
    key: "applyOverlayLayout",
    value: function applyOverlayLayout() {
      var el = document.getElementById("saito-overlay".concat(this.overlay.ordinal));
      var backdrop = document.getElementById("saito-overlay-backdrop".concat(this.overlay.ordinal));

      // Size to the panel (like SaitoTransactionMonitor). Do not force maximized-overlay —
      // that moves .saito-overlay-closebox to an inset position instead of the standard
      // top/right: -1rem hang-off used by SaitoOverlay.
      if (el) {
        el.classList.add('store-purchase-overlay-shell');
        el.classList.remove('maximized-overlay');
        el.style.pointerEvents = '';
      }
      if (backdrop) {
        backdrop.classList.add('store-purchase-overlay-backdrop');
        backdrop.style.display = 'block';
        backdrop.style.pointerEvents = 'auto';
        backdrop.style.top = '0';
        backdrop.style.left = '0';
        backdrop.style.width = '100vw';
        backdrop.style.height = '100dvh';
        backdrop.style.zIndex = '100001';
      }
      if (el) {
        el.style.zIndex = '100002';
      }
      if (typeof this.overlay.pullOverlayToFront === 'function') {
        this.overlay.pullOverlayToFront();
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _root$querySelector,
        _this4 = this;
      var root = document.querySelector('.purchase.complete');
      if (!root) {
        return;
      }
      (_root$querySelector = root.querySelector('[data-action="view-nfts"]')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('click', function (e) {
        e.preventDefault();
        _this4.openMyNfts();
      });
    }
  }, {
    key: "openMyNfts",
    value: function openMyNfts() {
      var _this$lifecycle, _this$lifecycle$retur;
      var active = (_this$lifecycle = this.lifecycle()) === null || _this$lifecycle === void 0 || (_this$lifecycle$retur = _this$lifecycle.returnActivePurchase) === null || _this$lifecycle$retur === void 0 ? void 0 : _this$lifecycle$retur.call(_this$lifecycle);
      if ((active === null || active === void 0 ? void 0 : active.phase) === PurchaseLifecycle.PHASE.COMPLETE) {
        var _this$lifecycle2;
        (_this$lifecycle2 = this.lifecycle()) === null || _this$lifecycle2 === void 0 || _this$lifecycle2.dismiss(active.id);
      }
      this.hide();
      this.app.connection.emit('saito-nft-list-render-request');
    }
  }, {
    key: "onStorePurchaseAsset",
    value: function onStorePurchaseAsset() {
      var _tx$returnMessage, _this$lifecycle3;
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        conf = _ref.conf,
        tx = _ref.tx;
      if (Number(conf) !== 0) {
        return;
      }
      var txmsg = (tx === null || tx === void 0 || (_tx$returnMessage = tx.returnMessage) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.call(tx)) || {};
      if (txmsg.module !== 'Store' || txmsg.request !== 'purchase-asset') {
        return;
      }
      if (this.pendingTxSignature && tx.signature !== this.pendingTxSignature) {
        return;
      }
      (_this$lifecycle3 = this.lifecycle()) === null || _this$lifecycle3 === void 0 || _this$lifecycle3.markPaymentConfirmed(this.pendingTxSignature);
      // Monitor auto-continues into openFulfilling via watchPurchase callback.
    }
  }, {
    key: "onStoreOrderRefund",
    value: function onStoreOrderRefund() {
      var _this$lifecycle4, _this$lifecycle5;
      var purchase = (_this$lifecycle4 = this.lifecycle()) === null || _this$lifecycle4 === void 0 ? void 0 : _this$lifecycle4.findByPurchaseTx(this.pendingTxSignature);
      if (!purchase) {
        return;
      }
      (_this$lifecycle5 = this.lifecycle()) === null || _this$lifecycle5 === void 0 || _this$lifecycle5.setPhase(purchase.id, PurchaseLifecycle.PHASE.DISMISSED, {
        status: 'Purchase refunded',
        detail: 'The Store could not fulfill this order.'
      });
      if (this.watchingWithMonitor) {
        var _this$mod$transaction3, _this$mod$transaction4;
        (_this$mod$transaction3 = this.mod.transaction_monitor) === null || _this$mod$transaction3 === void 0 || (_this$mod$transaction4 = _this$mod$transaction3.hide) === null || _this$mod$transaction4 === void 0 || _this$mod$transaction4.call(_this$mod$transaction3);
        this.watchingWithMonitor = false;
      }
      if (this.step) {
        this.hide();
      }
    }
  }, {
    key: "onLifecycleChange",
    value: function onLifecycleChange(purchase) {
      if (!purchase) {
        return;
      }
      if (purchase.phase === PurchaseLifecycle.PHASE.COMPLETE) {
        var _this$lifecycle6, _this$lifecycle6$hasW;
        var countArrived = !!((_this$lifecycle6 = this.lifecycle()) !== null && _this$lifecycle6 !== void 0 && (_this$lifecycle6$hasW = _this$lifecycle6.hasWalletCountIncreased) !== null && _this$lifecycle6$hasW !== void 0 && _this$lifecycle6$hasW.call(_this$lifecycle6, purchase));
        var matches = !this.pendingTxSignature || purchase.purchase_tx_signature === this.pendingTxSignature;
        if (!countArrived && !matches) {
          return;
        }
        this.listingTitle = purchase.title || this.listingTitle;
        this.pendingTxSignature = purchase.purchase_tx_signature;
        this.nft_id = purchase.nft_id;
        if (this.watchingWithMonitor) {
          var _this$mod$transaction5, _this$mod$transaction6;
          (_this$mod$transaction5 = this.mod.transaction_monitor) === null || _this$mod$transaction5 === void 0 || (_this$mod$transaction6 = _this$mod$transaction5.hide) === null || _this$mod$transaction6 === void 0 || _this$mod$transaction6.call(_this$mod$transaction5);
          this.watchingWithMonitor = false;
        }
        if (this.step !== 'complete') {
          this.openComplete();
        }
        return;
      }

      // Fulfilling overlay opens automatically when payment confirms.
    }
  }]);
}();
module.exports = PurchaseOverlay;